import * as React from 'react'
import Box from '@mui/material/Box'
import Avatar from '@mui/material/Avatar'
import Menu from '@mui/material/Menu'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import Tooltip from '@mui/material/Tooltip'
import Person2OutlinedIcon from '@mui/icons-material/Person2Outlined'
import useMediaQuery from '@mui/material/useMediaQuery'

import usePageInfo from '../../hooks/usePageInfo'
import {
    useContextsStore,
    selectIsPublicView,
} from '../../stores/useContextsStore'
import MenuItemsAuthUser from './MenuItemsAuthUser'
import { usePaywallStore } from '../Paywall/usePaywallStore'
import MenuItemsNotAuthUser from './MenuItemsNotAuthUser'

export default function AccountMenu({ onAccountMenuClick }) {
    const [anchorEl, setAnchorEl] = React.useState(null)
    const isPublic = useContextsStore(selectIsPublicView)
    const { location } = usePageInfo()

    const open = Boolean(anchorEl)
    const handleAnchorClick = event => {
        setAnchorEl(event.currentTarget)
        onAccountMenuClick()
    }
    const handleClose = () => {
        setAnchorEl(null)
    }

    // The MUI Menu traps focus while open; left open behind the upgrade
    // dialog it swallows every keystroke typed into the dialog's inputs.
    const upgradeDialogOpen = usePaywallStore(state => state.dialog.open)
    React.useEffect(() => {
        if (upgradeDialogOpen) setAnchorEl(null)
    }, [upgradeDialogOpen])

    React.useEffect(() => {
        if (window.myEventEmitter) {
            myEventEmitter.on('clickInfraNodus', () => {
                if (!open) {
                    setAnchorEl(
                        document.getElementById('appNameDisplay') ||
                            document.getElementById('customizationCaption')
                    )
                }
            })
        }
    }, [])

    const isMobile = useMediaQuery('(max-width:600px)')

    return (
        <React.Fragment>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    textAlign: 'right',
                }}
            >
                {location == 'apps' && !isMobile && (
                    <Typography
                        sx={{
                            marginRight: 1,
                            color: 'text.primary',
                            cursor: 'pointer',
                        }}
                        onClick={handleAnchorClick}
                    >
                        settings
                    </Typography>
                )}
                <Tooltip title="Account Settings" arrow={false}>
                    <IconButton
                        onClick={handleAnchorClick}
                        size="small"
                        aria-controls={open ? 'account-menu' : undefined}
                        aria-haspopup="true"
                        data-testid="account-menu-button"
                        aria-expanded={open ? 'true' : undefined}
                    >
                        <Avatar
                            sx={{
                                width: 32,
                                height: 32,
                                bgcolor: '#00B7FF',
                                color: '#ffffff',
                            }}
                        >
                            <Person2OutlinedIcon></Person2OutlinedIcon>
                        </Avatar>
                    </IconButton>
                </Tooltip>
            </Box>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflowY: 'auto',
                        overflowX: 'visible',
                        maxHeight: 'calc(100vh - 24px)',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                {isPublic ? <MenuItemsNotAuthUser /> : <MenuItemsAuthUser />}
            </Menu>
        </React.Fragment>
    )
}
